module.exports = __webpack_public_path__ + "img/tuts-rating-slider-desktop-6.cfd85613.png";